import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { useCloseAccountMutation } from '../../../../api/useCloseAccountMutation';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { fetchNetWorthData } from '../../../../../../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';

interface Props {
  clientId: string;
  accountId: string;
  managedAccountId: string;
  onClose(): void;
  onCloseAccountSuccess(): void;
}

export const CloseAccountModal: React.FC<Props> = ({
  clientId,
  accountId,
  managedAccountId,
  onClose,
  onCloseAccountSuccess,
}) => {
  const {
    mutateAsync: closeAccount,
    isLoading: isClosingAccount,
    error: closeAccountError,
  } = useCloseAccountMutation();

  const dispatch = useDispatch();

  const onCloseAccount = async () => {
    try {
      await closeAccount({ clientId, accountId, managedAccountId });

      dispatch(fetchNetWorthData(clientId));

      onCloseAccountSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader variant="warning">Close Account?</ModalHeader>

      <ModalBody>
        {closeAccountError && <Alert message={closeAccountError.message} variant="error" mb="16" />}

        <Text>Are you sure you want to close this account?</Text>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="error" onClick={onCloseAccount} isLoading={isClosingAccount} ml="8">
          Close Account
        </Button>
      </ModalFooter>
    </Modal>
  );
};
